import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { GUARDIAN_IP, GUARDIAN_TOKEN } from '../../../constants/general';
import { clear, isTokenStillValid } from '../../../misc/BrowserStorageManager';
import { history } from '../../../redux/store/configureStore';

const TABS = [
   { key: GUARDIAN_IP, label: 'IP' },
   { key: GUARDIAN_TOKEN, label: 'Playback Token' },
];

const TabsContainer = styled.div`
   display: flex;
   justify-content: center;
   padding: 0 15px;
   margin-top: 0px;
   border-bottom: 1px solid rgb(220, 220, 220);
   background: rgb(247, 248, 249);
`;
TabsContainer.displayName = 'TabsContainer';

const Label = styled.span`
   display: flex;
   align-items: center;
   font-size: 13px;
   color: #73818f;
   padding: 0 8px;
   white-space: nowrap;
`;
Label.displayName = 'Label';

const Tab = styled.button`
   padding: 8px 18px;
   font-size: 13px;
   font-weight: ${(p) => (p.$active ? '600' : '500')};
   border: none;
   border-bottom: 2px solid ${(p) => (p.$active ? '#20a8d8' : 'transparent')};
   margin-bottom: -1px;
   background: transparent;
   color: ${(p) => (p.$active ? '#20a8d8' : '#3d4a56')};
   cursor: pointer;
   transition: color 0.15s, border-color 0.15s;

   &:hover:not(:disabled) {
      color: #20a8d8;
   }

   &:focus {
      outline: none;
   }

   &:disabled {
      opacity: 0.5;
      cursor: default;
   }
`;
Tab.displayName = 'Tab';

function TableTypeTabs({ aggTerm, setAggTerm, activateTriggerRequest, disabled }) {
   function handleClick(key) {
      if (key === aggTerm) return;
      setAggTerm(key);
      activateTriggerRequest(true);
      if (!isTokenStillValid()) {
         const { pathname, search } = history.location;
         clear();
         history.push(pathname + search);
      }
   }

   return (
      <TabsContainer>
         <Label>Analyze data based on:</Label>
         {TABS.map(({ key, label }) => (
            <Tab key={key} type='button' $active={aggTerm === key} disabled={disabled} onClick={() => handleClick(key)}>
               {label}
            </Tab>
         ))}
      </TabsContainer>
   );
}

TableTypeTabs.propTypes = {
   aggTerm: PropTypes.string.isRequired,
   setAggTerm: PropTypes.func.isRequired,
   activateTriggerRequest: PropTypes.func.isRequired,
   disabled: PropTypes.bool,
};

export default TableTypeTabs;
